export default __webpack_public_path__ + "static/media/culture-large.1c4cc96f.svg";